<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Please wait...'"></div>
</div>

<div class="starting" *ngIf="isStarting">
  <img src="../../../../assets/img/logo1.svg" alt="" class="img">
</div>

<div *ngIf="!isStarting" class="login-page-custom">
  <div class="container-login">
    <div>
      <img src="../../../../assets/img/logo2.svg" alt="" class="img">
    </div>
    <div class="pb-5">
      <form #loginForm="ngForm" name="loginForm">

        <div class="form-group pb-3">
          <input #userEmail="ngModel" ngModel name="userEmail" type="email" class="form-control input-underline"
            aria-describedby="emailHelp" [attr.placeholder]="'login.email' | translate" required
            [class.is-invalid]="userEmail.invalid && userEmail.touched">
        </div>
        <div class="form-group pb-3">
          <show-hide-password icon="fa fa-eye-slash" btnStyle="primary" class="inputbotom">
            <input #userPassword="ngModel" ngModel name="userPassword" type="password"
              (keydown.enter)="attemptToLogin($event, loginForm)" class="form-control input-underline"
              [attr.placeholder]="'login.password' | translate" required>
          </show-hide-password>
        </div>
        <!-- <div class="error">
          {{error?.message}}
        </div> -->
        <div class="d-flex justify-content-end py-1">
          <div class="small-text remember-me d-flex align-items-center">
            <input type="checkbox" name="remember" [(ngModel)]="rememberMe" class="box" /><span translate>login.rememberMe</span>
          </div>
        </div>
        <br>
      </form>
      <div class="row col-12">
        <div class="button">
          <button class="btn login_button w-100" (click)="attemptToLogin($event, loginForm)" translate>login.login</button>
        </div>
        <div class="reset-password">
          <a href="/resetPassword" translate>login.resetPassword</a>
        </div>
      </div>
    </div>
  </div>
</div>